
const config = {
  API_URL: "https://rickandmortyapi.com/api/"
};;


export default config;
